export function pushToArray<T>(arr: T[], item: T): T[] {
  return [...arr, item];
}

export function findInArrayBy<T extends Record<string, unknown>>(
  arr: T[],
  val: unknown,
  key: keyof T = 'id' as keyof T,
): T | undefined {
  return arr.find((item) => item[key] == val);
}

export function findIndexInArrayBy<T extends Record<string, unknown>>(
  arr: T[],
  val: unknown,
  key: keyof T = 'id' as keyof T,
): number {
  return arr.findIndex((item) => item[key] == val);
}

export function insertItemToArray<T>(arr: T[], item: T, index: number): T[] {
  return [...arr.slice(0, index), item, ...arr.slice(index + 1)];
}

export function replaceItemInArray<T>(arr: T[], item: T, index: number): T[] {
  return [...arr.slice(0, index), item, ...arr.slice(index + 1)];
}

export function removeFromArray<T extends Record<string, unknown>>(
  arr: T[],
  val: unknown,
  key: keyof T = 'id' as keyof T,
): T[] {
  const index = findIndexInArrayBy(arr, val, key);
  if (index === -1) {
    return arr;
  }
  return [...arr.slice(0, index), ...arr.slice(index + 1)];
}

export function updateItemInArray<T extends Record<string, unknown>>(
  arr: T[],
  item: T,
  val: unknown,
  key: keyof T = 'id' as keyof T,
): T[] {
  const index = findIndexInArrayBy(arr, val, key);

  if (index === -1) {
    return pushToArray(arr, item);
  }

  return [...arr.slice(0, index), item, ...arr.slice(index + 1)];
}

export function isArray(obj: unknown): obj is unknown[] {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(obj) === '[object Array]';
  }
  return Array.isArray(obj);
}

/**
 * Function move item inside array
 * @param src array of items, where item should be moved
 * @param from index of item, which should be moved
 * @param to new item position
 * @returns new array of items
 */
export function moveItemInArray<T>(src: T[], from: number, to: number): T[] {
  const item = src[from];
  if (to > from) {
    return [
      ...src.slice(0, from),
      ...src.slice(from + 1, to + 1),
      item,
      ...src.slice(to + 1),
    ];
  }

  if (from > to) {
    return [
      ...src.slice(0, to),
      item,
      ...src.slice(to, from),
      ...src.slice(from + 1),
    ];
  }
  return src;
}
